import { createContext } from 'react'
import type { ActiveRaidModel } from '../types/schema'
import type { ResolveRaidResult, StartRaidInput } from '../services/raidService'
import type { RaidCurseDoc } from '../utils/raidCurse'

export interface RaidContextValue {
  activeRaid: ActiveRaidModel | null
  activeCurse: RaidCurseDoc | null
  isLoading: boolean
  startRaid: (input: StartRaidInput) => Promise<ActiveRaidModel>
  resolveRaid: (isVictory: boolean) => Promise<ResolveRaidResult>
}

export const RaidContext = createContext<RaidContextValue | undefined>(undefined)
